/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Tools_Splits_TitleInputs */

const en_ui_studio_tools_splits_title = /** @type {(inputs: Ui_Studio_Tools_Splits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split points`)
};

const de_ui_studio_tools_splits_title = /** @type {(inputs: Ui_Studio_Tools_Splits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilungspunkte`)
};

/**
* | output |
* | --- |
* | "Split points" |
*
* @param {Ui_Studio_Tools_Splits_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_tools_splits_title = /** @type {((inputs?: Ui_Studio_Tools_Splits_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Tools_Splits_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_tools_splits_title(inputs)
	return de_ui_studio_tools_splits_title(inputs)
});